export default window._cmsContent['solar/find-your-roof']